import React from 'react';
import 'assets/css/loader.css';

const Loader = ({message}) => {
  return (
    <div className="loader-overlay">
      <div className="loader"></div>
      <p className="loader-message">{message}</p>
    </div>
  );
};

export default Loader;
